import React, { useMemo } from 'react';
import { motion } from 'motion/react';
import './ParticleBackground.css';

const CARD_SYMBOLS = ['♠', '♥', '♦', '♣', '●', '•', '▪'];
const BOARD_SYMBOLS = ['🎲', '♟', '●', '•', '▪', '□', '△'];

const Particle = ({ symbol, size, duration, delay, x, startY, endY, opacity, blur }) => (
  <motion.div
    className="cyber-particle"
    initial={{ x, y: startY, opacity: 0 }}
    animate={{
      y: [startY, endY],
      opacity: [0, opacity, opacity, 0],
    }}
    transition={{
      duration,
      repeat: Infinity,
      delay: -delay,
      ease: "linear"
    }}
    style={{
      fontSize: size,
      left: 0,
      top: 0,
      filter: blur ? `blur(${blur}px)` : 'none',
      zIndex: blur ? 10 : 0
    }}
  >
    {symbol}
  </motion.div>
);

export default function ParticleBackground({ category = 'cards' }) {
  const symbols = category === 'boards' ? BOARD_SYMBOLS : CARD_SYMBOLS;

  const particles = useMemo(() => {
    const count = 120;
    const height = window.innerHeight;
    const startY = height + 100;
    const endY = -100;
    
    return Array.from({ length: count }).map((_, i) => {
      // Layering logic
      const layer = i % 3; // 0: Background, 1: Middle, 2: Foreground
      let size, duration, opacity, blur;

      if (layer === 0) { // Background: Tiny, slow, sharp
        size = Math.random() * 4 + 2;
        duration = Math.random() * 30 + 25;
        opacity = Math.random() * 0.2 + 0.05;
        blur = 0;
      } else if (layer === 1) { // Middle: Standard
        size = Math.random() * 10 + 6;
        duration = Math.random() * 20 + 15;
        opacity = Math.random() * 0.3 + 0.1;
        blur = 0;
      } else { // Foreground: Large, fast, blurred
        size = Math.random() * 25 + 15;
        duration = Math.random() * 10 + 8;
        opacity = Math.random() * 0.15 + 0.05;
        blur = Math.random() * 4 + 2;
      }

      return {
        id: i,
        symbol: symbols[i % symbols.length],
        size,
        duration,
        delay: Math.random() * duration,
        x: Math.random() * window.innerWidth,
        startY,
        endY,
        opacity,
        blur
      };
    });
  }, [symbols]);

  return (
    <div className="cyber-particle-container">
      {particles.map((p) => (
        <Particle key={p.id} {...p} />
      ))}
      <div className="cyber-grid-overlay" />
    </div>
  );
}
